import React from 'react';
import { Section } from './ui/Section';
export function Authority() {
  return <Section data-id="element-18">
      <div className="max-w-3xl mx-auto text-center" data-id="element-19">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-brand-title mb-6" data-id="element-20">
          ¿Quién está detrás de este Sistema?
        </h2>

        <div className="bg-white border border-brand-border rounded-2xl p-8 shadow-card" data-id="element-21">
          <p className="text-brand-text leading-relaxed mb-4" data-id="element-22">
            Creado por especialistas en pedagogía del baile y gestión de
            academias en España. Tras más de 15 años formando a cientos de
            alumnos y ayudando a instructores a profesionalizar sus clases,
            decidimos documentar el sistema que realmente funciona.
          </p>

          <p className="text-brand-subtitle font-semibold leading-relaxed" data-id="element-23">
            No es solo un manual; es la metodología que nosotros mismos usamos
            para pasar del caos en la planificación a tener salas llenas y
            alumnos que no quieren irse nunca. Nuestra misión: que enseñar
            sevillanas te devuelva la vida, no que te la quite.
          </p>
        </div>
      </div>
    </Section>;
}